import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LanguageService } from 'src/app/services/language.service';
import { ReferralsService } from 'src/app/services/referrals.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['./referrals.component.scss']
})
export class ReferralsComponent implements OnInit {
  public companyName: string = environment.company;
  public landingBaseLink: string = environment.links.landing_base_link;
  public referrals: Array<any> = [];
  public coupons: Array<any> = [];
  public language: string = this.languageService.getLanguage();
  public img_tyc: string = `assets/images/tyc_${this.language}.png`
  public clientInfo:any = JSON.parse(localStorage.getItem('user'));
  constructor(
    private toastr: ToastrService,
    private languageService: LanguageService,
    private referralsService: ReferralsService,
  ) { }

  ngOnInit(): void {
    this.getReferrals();
  }

  getReferrals() {
    this.referralsService.getReferrals().subscribe((res: any) => {
      this.referrals = res;
    });
  }

  copyToClipboard(language: string, username: string){
    let url = this.landingBaseLink;
    if (language == 'es') {
      url = url+'es/r/'+ username
    } else {
      url = url+'en/r/'+ username
    }
    navigator.clipboard.writeText(url);
    this.toastr.success($localize`Enlace copiado a portapapeles`)
  }

}
